import { render, staticRenderFns } from "./HeadingView.vue?vue&type=template&id=257d1303"
import script from "./HeadingView.vue?vue&type=script&lang=js"
export * from "./HeadingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports